import { createContext, useContext } from 'react';

import { RecommendationCard } from '@/components/widgets/o/RecommendationCard/types';

export interface CoPilotContextInterface {
  selectedRecommendationCard?: RecommendationCard | null;
  setSelectedRecommendationCard?: (recommendationCard: RecommendationCard | null) => void;
}

export type UseCoPilotContext = {
  selectedRecommendationCard: RecommendationCard | null;
} & CoPilotContextInterface;

export const CoPilotContext = createContext<CoPilotContextInterface | null>(null);

export const CoPilotContextProvider = CoPilotContext.Provider;

export const useSelectedRecommendationCard = () => {
  return useContext(CoPilotContext)?.setSelectedRecommendationCard;
};

export const useCoPilotContext = (): UseCoPilotContext => {
  const coPilotContextData = useContext(CoPilotContext);

  if (!coPilotContextData) {
    throw new Error(
      `The component that calls useSelectedRecommendationCard() needs to be a deep child of <CoPilotContextProvider>`,
    );
  }

  return coPilotContextData as UseCoPilotContext;
};
